export function parallaxImage() {
    if (typeof gsap === 'undefined' || typeof ScrollTrigger === 'undefined') return;

    gsap.registerPlugin(ScrollTrigger);

    document.querySelectorAll('.parallax').forEach(container => {
        const image = container.querySelector('img');
        if (!image) return;

        gsap.to(image, {
        yPercent: 20,
        ease: "none",
        scrollTrigger: {
            trigger: container,
            start: "top bottom",
            end: "bottom top",
            scrub: true,
        }
        });
    });
}